// Opening-state prompts the partner can click to run, in design order. Kept as i18n
// keys so the copy stays translatable; the box hands the resolved text to the chat page.
// Static for v1 — making these contextual to the partner's data is a later iteration.
export const INSIGHTS_AI_EXAMPLE_QUESTION_KEYS = [
  'typography.dashboard.insightsAi.examples.lastQuarter',
  'typography.dashboard.insightsAi.examples.topOrganizations',
  'typography.dashboard.insightsAi.examples.yearComparison'
] as const
